import { IdentityUserAri } from '@atlassian/ari/identity';

export const DEFAULT_AGENT_NAMED_ID: string = 'ai_mate_agent';

// This UUID is also used by the Solution Architect/default Rovo runtime identity;
// keep minion-verification attribution callers in sync if it ever changes.
export const DEFAULT_AGENT_UUID: string = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';

export const trimToUndefined: (value: string | null | undefined) => string | undefined = (
	value,
) => {
	const trimmed = value?.trim();
	return trimmed ? trimmed : undefined;
};

export const isDefaultRovoChat: (identity: {
	agentId?: string | null;
	agentNamedId?: string | null;
}) => boolean = ({ agentId, agentNamedId }) =>
	trimToUndefined(agentId) === DEFAULT_AGENT_UUID ||
	trimToUndefined(agentNamedId) === DEFAULT_AGENT_NAMED_ID;
export const normalizeAccountIdFromIdentityAri = (
	value: string | null | undefined,
): string | undefined => {
	const normalizedValue = trimToUndefined(value);
	if (!normalizedValue) {
		return undefined;
	}

	if (!normalizedValue.includes('ari:')) {
		return normalizedValue;
	}

	try {
		return trimToUndefined(IdentityUserAri.parse(normalizedValue).userId);
	} catch {
		return undefined;
	}
};
